import { useEffect, useState } from "react";
import IFBanner from "../components/IF_Template/IF_banner";
import { motion } from "framer-motion";
import { getTeam, getTeamCache } from "../services";
import IFSubMenu from "../components/IF_SubMenu";
import IFHeading from "../components/IF_Heading";

function SummonCoachCard({ coach, index }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: (index % 8) * 0.08, ease: "linear" }}
            className="h-full relative"
        >
            <div className="relative rounded-3xl bg-[#0c0e16] border border-white/10 group-hover:bg-transparent group-hover:border-transparent transition-all duration-500 group cursor-pointer h-full flex flex-col justify-between">
                {/* Main Character Summoning Chamber */}
                <div className="w-full aspect-[3/4] relative flex items-end justify-center">
                    {/* Vertical Summoning Light Aura (Shoots up from portal on hover) */}
                    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_90%,rgba(234,42,94,0.35)_0%,rgba(11,180,192,0.15)_45%,transparent_75%)] opacity-0 group-hover:opacity-100 scale-y-75 group-hover:scale-y-100 transition-all duration-500 origin-bottom pointer-events-none z-0" />

                    {/* Summoning Rune Platform / Perspective Circle at the Base */}
                    <div className="absolute bottom-6 inset-x-0 h-14 pointer-events-none z-10 flex items-center justify-center">
                        {/* Outer Perspective Energy Ring */}
                        <div
                            className="w-[85%] h-full rounded-full border border-biruMuda/30 group-hover:border-pink group-hover:scale-115 transition-all duration-500"
                            style={{
                                transform: "perspective(300px) rotateX(72deg)",
                                background: "radial-gradient(ellipse, rgba(234,42,94,0.32) 0%, rgba(11,180,192,0.15) 50%, transparent 75%)",
                            }}
                        />
                        {/* Inner Core Flare */}
                        <div
                            className="absolute w-1/2 h-1/2 rounded-full bg-[radial-gradient(ellipse,rgba(11,180,192,0.35)_0%,transparent_70%)] group-hover:bg-[radial-gradient(ellipse,rgba(234,42,94,0.7)_0%,transparent_70%)] transition-all duration-500 opacity-40 group-hover:opacity-100"
                            style={{ transform: "perspective(300px) rotateX(72deg)" }}
                        />
                    </div>

                    {/* Summoned Character Body (Rises & illuminates upon summon, breaking out of card) */}
                    <div className="relative z-15 w-full h-full flex items-end justify-center px-3 pt-4">
                        <img
                            alt="I-FIT Coach"
                            src={process.env.REACT_APP_IMAGE_ALBUM_URL + coach.filename}
                            loading="lazy"
                            className="w-full h-full object-contain object-bottom transition-all duration-500 ease-out transform translate-y-3 group-hover:translate-y-[-18px] scale-100 group-hover:scale-115 brightness-[0.75] contrast-[1.05] opacity-80 group-hover:brightness-[1.12] group-hover:contrast-[1.08] group-hover:opacity-100 select-none pointer-events-none"
                            style={{
                                maskImage: "linear-gradient(to bottom, black 82%, transparent 100%)",
                                WebkitMaskImage: "linear-gradient(to bottom, black 82%, transparent 100%)",
                            }}
                        />
                    </div>

                    {/* Bottom Ground Ambient Vignette (Fades away on hover to release character) */}
                    <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-[#0c0e16] via-[#0c0e16]/60 to-transparent pointer-events-none z-20 group-hover:opacity-0 transition-opacity duration-500" />

                    {/* Elevated Status Badge */}
                    <div className="absolute bottom-3 inset-x-3 text-center z-30 transition-transform duration-500 transform group-hover:translate-y-[-6px]">
                        <div className="px-3 py-1.5 rounded-full bg-[#08090d]/80 border border-white/15 group-hover:border-pink group-hover:bg-gradient-to-r group-hover:from-pink group-hover:to-ungu transition-all duration-500 inline-flex items-center gap-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-biruMuda group-hover:bg-white animate-pulse" />
                            <span className="text-[10px] sm:text-[11px] font-extrabold tracking-wider uppercase text-gray-300 group-hover:text-white transition-colors duration-300">
                                I-FIT CERTIFIED COACH
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

export default function Team() {
    const cached = getTeamCache();
    const [data, setDatas] = useState(() => cached || { datas: [], album: [] });
    const [load, setLoad] = useState(() => !cached || !cached.datas || cached.datas.length === 0);

    useEffect(() => {
        getTeam().then((res) => {
            if (res && res.datas && res.datas.length > 0) {
                setDatas(res);
            }
            setLoad(false);
        });
    }, []);

    if (load || !data.datas || data.datas.length === 0) {
        return (
            <div className="min-h-[70vh] w-full flex items-center justify-center">
                <div className="w-12 h-12 rounded-full border-4 border-white/20 border-t-pink animate-spin" />
            </div>
        );
    }

    return (
        <div className="flex flex-col w-full overflow-x-hidden">
            <IFBanner>
                <motion.div
                    initial={{ opacity: 0, x: 40 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.2, ease: "linear" }}
                >
                    <div className="max-w-[600px]">
                        <IFSubMenu
                            as="h1"
                            text1={data.datas[0]?.value}
                            text2={data.datas[1]?.value}
                        />
                        <p className="text-xs sm:text-sm md:text-base text-gray-300 leading-relaxed">
                            Tim pelatih bersertifikasi profesional I-FIT Indonesia berdedikasi membimbing dan mendampingi proses perbaikan postur tubuh serta peningkatan level kebugaran Anda dengan standar internasional.
                        </p>
                    </div>
                </motion.div>
            </IFBanner>

            <section className="py-12 md:py-20 px-4 md:px-8">
                <IFHeading>OUR PROFESSIONAL COACHES</IFHeading>

                <div className="max-w-[1300px] mx-auto mt-8">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
                        {data.album.map((t, index) => (
                            <SummonCoachCard key={index} coach={t} index={index} />
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
